import type DxfArrayScanner from 'dxf-parser/dist/DxfArrayScanner.js'
import type { IGroup } from 'dxf-parser/dist/DxfArrayScanner.js'
import type { IEntity, IPoint } from 'dxf-parser/dist/entities/geomtry.js'
import * as helpers from '@/plugins/cad/module/parser/parseHelpers'

/** DXF RAY 实体解析结果，描述一条从起点沿单位向量无限延伸的射线 */
export interface IDxfRayEntity extends IEntity {
  /** 射线起点 */
  startPoint?: IPoint
  /** 射线方向的单位向量 */
  unitVector?: IPoint
}

/** DXF RAY 实体解析器，注册到 dxf-parser 后用于射线实体解析 */
export default class RayEntityParser {
  /** dxf-parser 约定的实体名称键 */
  public ForEntityName = 'RAY' as any

  /**
   * 解析单个 RAY 实体。
   *
   * @param scanner - DXF 组码扫描器
   * @param curr - 当前已读取的组码项
   * @returns 解析后的 RAY 实体对象
   */
  public parseEntity(scanner: DxfArrayScanner, curr: IGroup) {
    const entity = { type: curr.value } as IDxfRayEntity
    curr = scanner.next()

    while (!scanner.isEOF()) {
      if (curr.code === 0) {
        break
      }

      switch (curr.code) {
        case 10:
          entity.startPoint = helpers.parsePoint(scanner)
          break
        case 11:
          entity.unitVector = helpers.parsePoint(scanner)
          break
        default:
          helpers.checkCommonEntityProperties(entity, curr, scanner)
          break
      }

      curr = scanner.next()
    }

    return entity
  }
}
